import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { filter, forkJoin, map } from 'rxjs';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';

import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';


// TODO llevar al configurador comportamiento paginas seccion menu
export const CONFIGURACION_MENU_DEFAULT = {
  float: 'mainHeader-float',
  normalStyle: 'negative',
  stickyStyle: 'color',
  burgerStyle: 'color',
  menuInline: true,
  buttonCta: true,
  configuracionButtonCta: { otroUso: true, path: PAGINAS_ROUTES.PAGINA_RESERVAR, label: 'Reservar', target: 'Reservar' },
  menuUser: true,
  menuIdiomas: false,
  menuBurger: true,
};

export const CONFIGURACIONPAGINA =
{
  menuActivo: true,
  menu: Object.assign({}, CONFIGURACION_MENU_DEFAULT),
  scrollUp: true,
  paddingTop: true,
  paddingBottom: true,
} 


@Component({
  selector: 'neo-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  proximamente_dlg;
  configuracionPagina =
    {
      menuActivo: true,
      menu: Object.assign({}, CONFIGURACION_MENU_DEFAULT),
      scrollUp: true,
      paddingTop: true,
      paddingBottom: true,
    } 

  mainHeaderElementos: any;
  inicioFront : boolean = true;

  configuracionExtra;

  telefono1;
  email1;

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.actualizarDispositivo(false);
  }
  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public router: Router,
    private route: ActivatedRoute,
    private service: TranslocoService,
    private edicionSeccionesService: EdicionSeccionesService,
    private helpersService: HelpersService,
    private preferenciasService: PreferenciasService
  ) { 
    this.renderer.removeClass(document.body, 'main');
    this.renderer.addClass(document.body, 'mainFront');

    this.router.events
      .pipe(
        filter((event) => (event instanceof NavigationEnd || event instanceof ActivationEnd)),
        filter((evento: ActivationEnd | NavigationEnd) => (evento instanceof ActivationEnd && evento['snapshot'].firstChild === null) || evento instanceof NavigationEnd),
        map((evento: ActivationEnd | NavigationEnd) => {
          return evento
        })
      )
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.inicioFront = (event.url == '/inicio' || event.url == '/' || event.url == '/areaCliente' || event.url == 'authF');
        }
        if (event instanceof ActivationEnd) {
          this.configuracionExtra = event.snapshot.data;          
        }
        this.establecerOpcionesMenu(this.inicioFront, this.configuracionExtra?.configuracionPagina);

        // si proximamente
        console.log('State ', this.router.getCurrentNavigation()?.extras?.state);
        // this.proximamente_dlg = this.router.getCurrentNavigation()?.extras?.state;
      });
  }

  ngOnInit(): void {
    this.inicializarDispositivo();
    this.service.setActiveLang('es');
    // this.service.selectTranslate('hello').subscribe(value => console.log('traduccion', value));
    this.route.data.subscribe(
      response => {
        if (response['mainHeader']) {
          this.mainHeaderElementos = response['mainHeader'];
        }
      }
    );
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-hq').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;   
          this.telefono1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-tel1', indice);    
          this.email1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-mail1', indice);     
        })
      })
    } else {
      this.telefono1 = this.preferenciasService.get('contacto_telefono');
      this.email1 = this.preferenciasService.get('contacto_email');
    }
  }

  // comportamiento menu segun pagina
  establecerOpcionesMenu(paginaInicial: boolean, configuracion?) {
    if (configuracion) {
      this.configuracionPagina = { ... this.configuracionPagina, ...configuracion }
    } else {
      this.configuracionPagina = Object.assign({}, CONFIGURACIONPAGINA)
    }
    if (paginaInicial) {
      this.configuracionPagina.menu = Object.assign({}, CONFIGURACION_MENU_DEFAULT);
    } else {
      this.configuracionPagina.menu.float = '';
      this.configuracionPagina.menu.normalStyle = 'color';
    }
  }
  // layout.js
  inicializarDispositivo() {
    let tipo = this.obtenerTipo();
    this.renderer.addClass(document.documentElement, tipo);
    this.actualizarDispositivo(true);
  }

  actualizarDispositivo(inicial) {
    let tipo = this.obtenerTipo();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    // // orientacion
    var cambioVH = true;
    this.renderer.setAttribute(document.documentElement, 'data-orientation', 'landscape');
    if (tipo == 'mobile') {
        if (inicial) {
            if (vw / vh > 1) {
              this.renderer.setAttribute(document.documentElement, 'data-orientation', 'landscape');
            } else {
              this.renderer.setAttribute(document.documentElement, 'data-orientation', 'portrait');
            }
        } else {
            if (vw / vh >= 1 && document.documentElement.hasAttribute('data-orientation') &&  document.documentElement.getAttribute('data-orientation') == 'portrait') {
                this.renderer.setAttribute(document.documentElement, 'data-orientation', 'landscape');
            } else if (vw / vh < 1 &&  document.documentElement.hasAttribute('data-orientation') &&  document.documentElement.getAttribute('data-orientation') == 'landscape') {
              this.renderer.setAttribute(document.documentElement, 'data-orientation', 'portrait');
            } else {
                // el vh en mobile sólo se va a actualizar cuando haya un cambio de orientacion, para prevenir el bug de la barra de direcciones al hacer scroll
                cambioVH = false;
            }
        }
    }
    // viewport
    document.documentElement.style.setProperty('--viewportWidth', vw + 'px');
    if (cambioVH) {
        document.documentElement.style.setProperty('--viewportHeight', vh + 'px');
    }
  }
  obtenerTipo() {
    let tipo = 'desktop';
    if ('ontouchstart' in document.documentElement) {
        tipo = 'mobile';
    }
    return tipo;
  }

}
